import IDOList from '../components/IDO/IDOList';

const IDOListPage: React.FC = () => {
	return <IDOList />;
};

export default IDOListPage;
